/*
  05 #9 "In stock" (UI overhaul wave 3): what the stores hold of this project's BOQ parts —
  GET /projects/{id}/material-stock → { items: { [part]: { available, on_hand, reserved_here, locations } },
  locations, checked_at }. Loaded only while the Material tab shows BOQ lines; a failure just hides the
  column (the BOQ never waits on it).
*/
import { useEffect, useState } from 'react';
import api from '@/lib/api';

export function useMaterialStock(projectId, { enabled = true, refreshKey } = {}) {
  const [state, setState] = useState({ data: null, loading: false, error: '' });
  useEffect(() => {
    if (!enabled || !projectId) return undefined;
    let cancelled = false;
    setState((prev) => ({ ...prev, loading: true, error: '' }));
    api.get(`/projects/${projectId}/material-stock`)
      .then((res) => { if (!cancelled) setState({ data: res.data || null, loading: false, error: '' }); })
      .catch(() => { if (!cancelled) setState({ data: null, loading: false, error: 'Store stock could not be read' }); });
    return () => { cancelled = true; };
  }, [projectId, enabled, refreshKey]);
  return state;
}
